<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2></h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
           <li>
            <a [routerLink]="'/'+AppFrontRoutes.REPORTING">{{ lang.reporting }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">

            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                        <div class="form-group col-sm-12">
                          <div class="form-group col-sm-6">
                            <label>{{ lang.customer }}</label>

                            <ng-multiselect-dropdown formControlName="customer_id" [data]="app_customers"
                              [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>


                          </div>


                          <div class="form-group col-sm-6 datepicker">
                            <div class="col-sm-6">
                              <label>{{ lang.dateFrom }}</label>
                              <input type="date" class="form-control" formControlName="start_date">
                            </div>  

                            <div class="col-sm-6">
                              <label>{{ lang.dateTo }}</label>
                              <input type="date" class="form-control" formControlName="end_date">
                            </div>  
                            
                          </div>


                        </div>

                        <div class="form-group col-sm-12">
                          <div class="form-group col-sm-6">

                            <label>{{ lang.consultancyCode }}</label>
                            <ng-multiselect-dropdown formControlName="codes_id" [data]="app_codes"
                              [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>


                          </div>

                          <div class="form-group col-sm-6">
                            <label>{{ lang.employees }}</label>

                            <ng-multiselect-dropdown formControlName="employee_id" [data]="app_employee"
                              [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>


                          </div>

                        </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel-footer" style="z-index:1030;position:relative">
              <input type="hidden" name="action" value="search_process">
              <input name="search" class="btn btn-light-grey" value="Search" type="submit">
              <input name="rest" class="btn btn-light-greenn reset_btn" value="Reset" type="reset">
            </div>

          </form>

          </div>
        </div>
      </div>

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        </div>
                      </div>

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover" id="table1">
                        <thead>
                          <tr>
                            <!-- <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th> -->
                            <th>No.</th>
                            <th>{{ lang.reportno }}</th>
                            <th>{{ lang.code }}</th>
                            <th>{{ lang.customer }}</th>
                            <th>{{ lang.date }}</th>
                            <th>{{ lang.type }}</th>
                            <th>{{ lang.performedBy }}</th>
                            <th>{{ lang.performedActivities }}</th>
                            <th>{{ lang.totalHours }}</th>
                            <th>{{ lang.kmTraveled }}</th>
                            <th>{{ lang.costofBoard }}</th>
                            <th>{{ lang.otherCosts }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let record of reports let i = index" id="{{record.doc_id}}">
                            <!-- <td>{{i+1}}</td>
                            <td></td> -->
                            <td>{{i+1}}</td>
                            <td>{{record.report_no}}</td>
                            <td>{{record.consultancy_code}}</td>
                            <td>{{record.employee_name }}</td>
                            <td>{{record.date }}</td>
                            <td>{{record.type }}</td>
                            <td>{{record.performed_by }}</td>
                            <td>{{record.performed_activities }}</td>
                            <td>{{record.total_hour }}</td>
                            <td>{{record.km_traveled }}</td>
                            <td>{{record.cost_lodging }}</td>
                            <td>{{record.other_costs }}</td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>


                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left uppercase">{{ lang?.importDocument }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a [routerLink]="">click here</a> to download to csv format file
              </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ mLang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ mLang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ mLang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<script type="text/javascript">

</script>